import { AttendanceModal } from "master/components";
import { useAttendanceHandler } from "master/hooks";
import { createContext } from "react";

export const AttendanceContext = createContext();

export const AttendanceScope = (props) => {
  const {
    onClickProgram,
    enable,
    onCloseModal,
    onCheckIn,
    newDate,
    attendanceMarking,
  } = useAttendanceHandler();

  return (
    <AttendanceContext.Provider value={{ onClickProgram }}>
      <>
        {enable && (
          <AttendanceModal
            enable={enable}
            onCloseModal={onCloseModal}
            onCheckIn={onCheckIn}
            newDate={newDate}
            attendanceMarking={attendanceMarking}
          />
        )}
        {props.children}
      </>
    </AttendanceContext.Provider>
  );
};
